/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let log: any;
declare let base: any;
declare let hall: any;
declare let WebDefine: any;
import { ModuleBase } from './ModuleBase'

export class CustomerModule extends ModuleBase {
  private customerEmail_: string = '' //邮箱链接
  private customerTG_: string = '' //客服跳转链接

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {
    log('CustomerModule onPreloadData')
    //this.getFeedbackEmail()
  }

  getFeedbackEmail(): void {
    const data = {
      cid: base.channelId,
      // uid: hall.userModule.userId,
      uid: 1111, // 因为要在登录前获取邮箱，所以 uid 随便填一个即可
    }
    //  获取客服邮箱和 tg
    base.httpUtil
      .postJson(WebDefine.tg, data)
      .then((respJson) => {
        log('CustomerModule success:', respJson)
        this.customerEmail_ = respJson.data.email
        this.customerTG_ = respJson.data.tg_url

        hall.eventDispatcher.emit(hall.EventDefine.CustomerInfoChange)
      })
      .catch((_error: any) => {
        log('error:', _error)
      })
  }

  getCustomerInfo(): string {
    return this.customerTG_
  }

  getEmailInfo(): string {
    return this.customerEmail_
  }
}
